import React, { useEffect, useState } from "react";
import { MsalProvider } from "@azure/msal-react";
import { LinearProgress } from "@material-ui/core";
import { msalInstance } from "~/packages/msalInstance";

interface Props { children?: React.ReactNode; }

const MsalInitializer = ({ children }: Props) => {
  const [ready, setReady] = useState(false);
  
  useEffect(() => {
    let mounted = true;

    (async () => {
      try {
        if (msalInstance && typeof (msalInstance as any).initialize === "function") {
          await (msalInstance as any).initialize();
        }
      } catch (err) {
        console.error("msal initialize failed", err);
      } finally {
        if (mounted) setReady(true);
      }

    })();

    return () => { mounted = false; };
  }, []);

  if (!ready) return <LinearProgress />;

  return <MsalProvider instance={msalInstance}>{children}</MsalProvider>;
};

export default MsalInitializer;